import React from "react";
import {connect} from "react-redux";
import {Button, Form, Input, Modal, Select, Space, message} from "antd";
import {createFirewallRuleset, loadFirewallRules, loadFirewallRulesets} from "../../actions/firewall";
import {displayErrors} from "../../libs/utils";

class NewFirewallRulesetModal extends React.Component {
    state = {
        name: '',
        rules: [],
        selectedRules: [],
        loadingRules: true,
        loadingData: false,
        dataLoaded: false,
        creating: false
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(!this.state.loadingData && this.props.showModal && !this.state.dataLoaded) {
            this.props.loadFirewallRules(1, 9999, (res) => {
                let rules = res.data.data.map((rule) => {
                    return { label: rule.name, value: rule.guid };
                });

                this.setState({ rules, loadingRules: false, dataLoaded: true });

            }, (err) => {
                if(typeof err.response !== 'undefined') {
                    this.setState({ loadingRules: false, dataLoaded: true });
                    displayErrors(err.response.data);
                }
            });
        }
    }

    closeModal(reload = false) {
        this.props.close();

        this.setState({
            name: '',
            rules: [],
            selectedRules: [],
            loadingRules: true,
            loadingData: false,
            dataLoaded: false,
            creating: false
        });

        if(reload) {
            this.props.reloadRulesets();
        }
    }

    createRuleset() {
        let name = this.state.name.trim();
        let rules = this.state.selectedRules;

        if(name.length === 0) {
            return message.error('Enter your ruleset\'s name!');
        }

        if(rules.length === 0) {
            return message.error('Select at least 1 firewall rule!');
        }

        this.setState({ creating: true });

        let data = { name, rules };

        this.props.createFirewallRuleset(data, () => {
            message.success('Firewall ruleset successfully created!');
            this.setState({ creating: true });
            this.closeModal(true);
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                this.setState({ creating: false });
                displayErrors(err.response.data);
            }
        });
    }

    render() {
        return(
            <Modal
                title='Add New Ruleset'
                open={this.props.showModal}
                destroyOnClose={true}
                footer={
                    <Space>
                        <Button onClick={() => this.closeModal()}>Close</Button>
                        <Button type='primary' onClick={() => this.createRuleset()}>Create</Button>
                    </Space>
                }
                onCancel={() => this.closeModal()}>

                <Form layout='vertical'>
                    <Form.Item label='Name'>
                        <Input value={this.state.name} onChange={(e) => this.setState({ name: e.target.value })} />
                    </Form.Item>
                    <Form.Item label='Rules' extra={<small>Select 1 or more firewall rules.</small>}>
                        <Select
                            options={this.state.rules}
                            loading={this.state.loadingRules}
                            mode='multiple' showSearch allowClear
                            onChange={(values) => this.setState({ selectedRules: values })}
                            filterOption={(input, option) => {
                                if(typeof option !== 'undefined') {
                                    return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                }
                                return false;
                            }} />
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}

export default connect(null, { loadFirewallRules, loadFirewallRulesets, createFirewallRuleset })(NewFirewallRulesetModal);